<template>
  <div>
    <HeroInfo v-if="$whitelabel.isStandalone" v-show="$route.path === '/'" />
    <div class="container">
      <!-- <GreenstormMoneyBack v-if="$whitelabel.short.toLowerCase() === 'greenstorm'" v-show="$route.path === '/'" /> -->

      <div v-if="!$whitelabel.isStandalone" v-show="$route.path === '/'">
        <Advantages v-bind:size="$whitelabel.homepage.advantages" v-if="$whitelabel.homepage.advantages" class="mb-4" />
      </div>

      <SearchContainer v-on:update:breadcrumb="currentBreadcrumb = $event" />
    </div>
  </div>
</template>

<script>
import SearchContainer from '@/modules/search'
import HeroInfo from '@/components/HeroInfo'
import Advantages from '@/components/Advantages'
// import GreenstormMoneyBack from '@/components/Banner/Greenstorm/GreenstormMoneyBack'
export default {
  name: 'search',
  components: {
    SearchContainer,
    HeroInfo,
    // GreenstormMoneyBack,
    Advantages,
  },
  breadcrumb() {
    return {
      label: /*this.$route.params.country || this.$route.params.name*/ this.currentBreadcrumb,
      parent: 'search',
    }
  },
  data() {
    return {
      currentBreadcrumb: '',
    }
  },
}
</script>
